/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=1670f9e7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1670f9e7&lang=less"

import exportComponent from "/root/workspace/coottlVideoPage_JjFl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__